import React, { Component, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as actionCreators from "../actions/apps";
import { setUserIsPatient } from "../actions/user";
import AppService from "../services/apps";

import { Link } from "react-router-dom";
import _ from "lodash";
import Loader from "react-loader-advanced";
import { List } from "material-ui/List";

import AppFrame from "./Appframe/AppFrame";
import ActionDialogue from "../components/common/ActionDialogue";
import InviteUser from "../components/common/InviteUser";
import WrapDialogue from "../components/common/WrapDialogue";
import NormalTextField from "../components/common/NormalTextField";
import { Button, DialogContent } from "@material-ui/core";

import colors from "../styles/colors";
import { colorsV2 } from "../styles/colors";
import layout from "../styles/layout";

import { Dialog } from "material-ui";
import AppListItem from "./AppListItem";
import { Mixpanel } from "../mixpanel";

import "../resources/styles/UserAppsViewer.css";
import CSAT from "../components/survey/CSAT";
import GuidedTour from "../components/guide/GuidedTour";
import events from "../services/events";
import AddPatient from "../components/common/AddPatient";

const style = {
  page: {
    display: "flex",
    flexFlow: "column",
    padding: 40,
    minHeight: "100vh",
    width: "100%",
  },
  container: {
    margin: 10,
    padding: 10,
  },
  table: {
    tableLayout: "auto",
  },
  titleColumn: {
    width: "40%",
  },
  codeColumn: {
    width: "12%",
  },
  buttonColumn: {
    width: "12%",
  },
  titleColumnText: {
    fontSize: 20,
  },
  codeColumnText: {
    fontSize: 18,
    color: colors.action,
  },
  listStyle: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
  },
};

class UserAppsViewer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      userId: props.user.userId,
      appInfos: {},
      customApps: {},
      isPatient: props.user.isPatient,
      selectedAppId: -1,
      selectedAppIsLibOnly: false,
      cloneAppInfo: {},
      removeAppDialogData: {},
      popoverOpen: false,
      popoverAnchorEl: null,
      currentApp: null,
      width: 0,
      height: 0,
      sentOk: false,
      showCsat: false,
    };

    this.editApp = this.editApp.bind(this);
    this.manageUsers = this.manageUsers.bind(this);
    this.subscription = this.subscription.bind(this);
    this.removeApp = this.removeApp.bind(this);
    this.removeAppDialog = this.removeAppDialog.bind(this);
    this.inviteUser = this.inviteUser.bind(this);
    this.cloneApp = this.cloneApp.bind(this);
    this.cloneAppDialogue = this.cloneAppDialogue.bind(this);
    this.inviteSent = this.inviteSent.bind(this);
    this.renderCSAT = this.renderCSAT.bind(this);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions.bind(this));
  }

  componentWillUnmount() {
    window.removeEventListener(
      "resize",
      this.updateWindowDimensions.bind(this)
    );
  }

  componentWillMount() {
    if (this.state.userId && this.state.userId > 0) {
      this.props.providerAppId(null);
      this.props.getUserApps(this.state.userId); // use this.state.userId to fix loading at refresh (rehydrate after request)
      this.props.getCustomApps(this.state.userId);
    } else {
      if (this.props.userId && this.props.userId > 0) {
        this.setState({ userId: this.props.userId });
        this.props.getUserApps(this.props.userId);
        this.props.getCustomApps(this.props.userId);
      } else {
        // wait for login to complete and user Id come in
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    if (!this.state.userId || this.state.userId < 1) {
      // was waiting for userId, now set userId and request to get appInfo
      if (nextProps.user.userId || nextProps.user.userId > 0) {
        this.setState({ userId: nextProps.user.userId });
        this.props.getUserApps(nextProps.user.userId);
        this.props.getCustomApps(nextProps.user.userId);

        //Check to see if the use should fill out a csat survey
        try {
          AppService()
            .getCSATRequired(nextProps.user.userId)
            .then((resp) => {
              if (resp.appId) {
                this.setState({
                  showCsat: true,
                  csatData: resp,
                });
              }
            })
            .catch((err) => {});
        } catch (ex) {
          console.log(ex);
        }
      }
    } else {
      this.setState({
        appInfos: nextProps.apps.appInfos,
        isPatient: nextProps.user.isPatient,
        customApps: nextProps.apps.customApps,
      });
    }

    //When apps refresh see if any new apps exist and then set the store user to a provider in redux

    if (
      this.state.isPatient &&
      nextProps.user.isPatient &&
      !_.isEmpty(nextProps.apps.appInfos, true)
    ) {
      this.props.setUserIsPatient(false);
    }
  }

  editApp(app) {
    events().trackUserEvent(
      "Edit Channel",
      app.appId,
      null,
      null,
      null,
      this.props.user.userId,
      null,
      "portal",
      app.appName,
      null,
      null
    );
    let link = `/view-app-detail/${app.appId}`;
    this.props.providerAppId(app.appId);

    this.props.getAppTemplate(this.state.userId, app.appId, 103);
    this.props.getAppFavorites(app.appId, this.props.user.userId);
    this.props.history.push(link);
  }

  manageUsers(app) {
    events().trackUserEvent(
      "View Channel",
      app.appId,
      null,
      null,
      null,
      this.props.user.userId,
      null,
      "portal",
      app.appName,
      null,
      null
    );
    let link = `/manage-users/${app.appId}`;
    this.props.providerAppId(app.appId);
    this.props.history.push(link);
  }

  openAppDashboard(userId, appId, type, appName, customAppId) {
    let link = `/patient-dashboard/${appId}/${userId}/${type}/${customAppId}`;
    Mixpanel.track("View channel", {
      "User Id": userId,
      "Channel ID": appId,
      "Channel Type": type,
      "Channel Name": appName,
      isProvider: false,
      Platform: "Web",
    });

    events().trackUserEvent(
      "View Channel",
      appId,
      customAppId,
      null,
      null,
      userId,
      null,
      "portal",
      appName,
      null,
      null
    );

    this.props.history.push(link);
  }

  inviteUser(appId, appName, appType, app) {
    this.setState({
      selectedAppId: appId,
      selectedAppName: appName,
      selectedAppIsLibOnly: appType === "LibraryOnly",
      selectedApp: app,
      inviteOpen: true,
    });
  }

  inviteSent() {
    this.setState({ sentOk: true });
    setTimeout(() => this.setState({ sentOk: false }), 3000);
    this.refs.inviteUserDialogue.close();
  }

  inviteUserDialogue() {
    return (
      <AddPatient
        open={this.state.inviteOpen}
        appId={this.state.selectedAppId}
        userId={this.state.userId}
        appName={this.state.selectedAppName}
        isLibOnly={this.state.selectedAppIsLibOnly}
        app={this.state.selectedApp}
        close={() => this.setState({ inviteOpen: false })}
      />
    );
  }

  renderCSAT() {
    return (
      <div>
        <CSAT
          open={this.state.showCsat}
          onClose={() => {
            this.setState({ showCsat: false });
          }}
          provider={this.state.csatData ? this.state.csatData.providerName : ""}
          practice={this.state.csatData ? this.state.csatData.clinicName : ""}
          appId={this.state.csatData ? this.state.csatData.appId : null}
          userId={this.state.userId}
          providerId={
            this.state.csatData ? this.state.csatData.providerId : null
          }
          webReviewEnabled={
            this.state.csatData ? this.state.csatData.webReviewEnabled : false
          }
          googleReviewUrl={
            this.state.csatData ? this.state.csatData.googleReviewUrl : ""
          }
          yelpReviewUrl={
            this.state.csatData ? this.state.csatData.yelpReviewUrl : ""
          }
        />
      </div>
    );
  }

  subscription(appId) {
    let link = `/app-subscription/${appId}`;
    this.props.history.push(link);
  }

  removeApp(userId, appId, appName) {
    this.setState({
      removeAppDialogData: { userId, appId, appName },
    });

    this.refs.removeAppConfDialogue.open();
  }

  cloneApp(appId, appInfo) {
    this.setState({
      selectedAppId: appId,
      cloneAppInfo: appInfo,
    });
    this.refs.cloneAppDialogue.open();
  }

  cloneAppDialogue() {
    const setCloneAppInfo = (event) => {
      let cloneAppInfo = Object.assign({}, this.state.cloneAppInfo, {
        [event.target.name]: event.target.value,
      });
      this.setState({ cloneAppInfo });
    };
    return (
      <ActionDialogue
        ref="cloneAppDialogue"
        title="Clone Channel"
        content={
          <div>
            <NormalTextField
              floatingLabelText="Channel Name"
              name="appName"
              fullWidth={true}
              errorText={
                _.isEmpty(this.state.cloneAppInfo.appName)
                  ? "This field is required"
                  : ""
              }
              value={this.state.cloneAppInfo.appName}
              onChange={(event) => setCloneAppInfo(event)}
            />
            <NormalTextField
              floatingLabelText="Provider"
              name="author"
              fullWidth={true}
              errorText={
                _.isEmpty(this.state.cloneAppInfo.author)
                  ? "This field is required"
                  : ""
              }
              value={this.state.cloneAppInfo.author}
              onChange={(event) => setCloneAppInfo(event)}
            />
          </div>
        }
        onConfirm={() =>
          this.props.cloneApp(
            this.props.userId,
            this.state.selectedAppId,
            this.state.cloneAppInfo
          )
        }
      />
    );
  }

  deleteAChannel(data) {
    this.props.invalidateApp(data.userId, data.appId);
    Mixpanel.track("Remove channel", {
      "User ID": data.userId,
      "Channel ID": data.appId,
      "Channel Name": data.appName,
      Platform: "Web",
    });
  }
  removeAppDialog() {
    let data = this.state.removeAppDialogData;
    let title = `Remove Channel: ${data.appName}`;

    return (
      <ActionDialogue
        ref="removeAppConfDialogue"
        title={title}
        content="Are you sure you want to remove this Channel?"
        onConfirm={() => this.deleteAChannel(data)}
      />
    );
  }

  handlePopoverClose = () => {
    this.setState({
      popoverOpen: false,
      popoverAnchorEl: null,
    });
  };

  renderAppsList(listA, listB) {
    const myApps = _.values(listA);
    const myPatientApps = _.values(listB).filter(
      (i) =>
        i.appInfo.appStatus !== "Default" &&
        i.appInfo.ownerUserId !== this.state.userId &&
        i.hasAccess
    );

    return (
      <List style={style.listStyle} className="channels-list">
        {myApps.map((app, idx) => {
          return (
            <AppListItem
              key={app.appId}
              app={app}
              isPatient={false}
              editApp={() => this.editApp(app)}
              inviteUser={() =>
                this.inviteUser(app.appId, app.appName, app.appType, app)
              }
              openChannel={() => {
                this.manageUsers(app);
              }}
              subscription={(appId) => this.subscription(appId)}
              cloneApp={(appId, app) => this.cloneApp(appId, app)}
              removeApp={(appId, appName) =>
                this.removeApp(this.state.userId, appId, appName)
              }
              isFirst={idx === 0}
              whiteLabelSettings={this.props.whiteLabelSettings}
            />
          );
        })}
        {myPatientApps.map((app) => (
          <AppListItem
            key={app.appId}
            app={app.appInfo}
            customAppId={app.customAppId}
            isPatient={true}
            whiteLabelSettings={this.props.whiteLabelSettings}
            openChannel={() => {
              this.openAppDashboard(
                this.state.userId,
                app.appInfo.appId,
                app.appInfo.appType,
                app.appInfo.appName,
                app.customAppId
              );
            }}
          />
        ))}
        {myPatientApps.length === 0 && myApps.length === 0 && (
          <h3>No channels to display</h3>
        )}
      </List>
    );
  }

  render() {
    return (
      <AppFrame
        auth={this.props.auth}
        header="My Channels"
        optionsType="channels"
        whiteLabelSettings={this.props.whiteLabelSettings}
      >
        <div style={style.page}>
          <Loader show={this.props.apps.isLoading} message={"Loading..."}>
            {this.renderCSAT()}
            <div>
              {this.renderAppsList(this.state.appInfos, this.state.customApps)}
            </div>
            {this.removeAppDialog()}
            {this.inviteUserDialogue()}
            {this.cloneAppDialogue()}
            {this.props.tour && this.props.tour.tourVisible && (
              <GuidedTour run={true} continuously={true} />
            )}
          </Loader>
          <Dialog modal={false} open={this.state.sentOk}>
            Invitation Sent Successfully
          </Dialog>
        </div>
      </AppFrame>
    );
  }
}

function mapStateToProps({ user, apps, customApps, tour, whiteLabelSettings }) {
  return {
    userId: user.userId,
    user,
    apps,
    customApps,
    tour,
    whiteLabelSettings,
  };
}

function mapDispatchToProps(dispatch) {
  let allActions = { ...actionCreators, setUserIsPatient };
  return bindActionCreators(allActions, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(UserAppsViewer);



// WEBPACK FOOTER //
// ./src/layout/UserAppsViewer.js